
import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Contact } from "@/components/Contact";
import { ContactForm } from "@/components/ContactForm";
import { ClientLogos } from "@/components/ClientLogos";
import { Footer } from "@/components/Footer";
import { OurStory } from "@/components/OurStory";
import { OurMission } from "@/components/OurMission";
import { AboutUs } from "@/components/AboutUs";
import { useTheme } from "@/contexts/ThemeContext";

const Index = () => {
  const { colors } = useTheme();
  
  return (
    <div className="overflow-x-hidden transition-colors duration-300" style={{ backgroundColor: colors.background }}>
      <Navigation />
      <div className="min-h-screen w-full">
        <Hero />
        <Services />
        <AboutUs />
        <OurStory />
        <OurMission />
        <ClientLogos />
        <section id="contact" className="py-12 md:py-20" style={{ backgroundColor: colors.background }}>
          <div className="max-w-6xl mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-stretch">
              <Contact />
              <ContactForm />
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default Index;
